import { render } from "./EmptyPage.vue?vue&type=template&id=68dd0fce"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__